import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { FaTimes } from "react-icons/fa";
import { FormattedMessage } from "react-intl";
import OutlinedButton from "../../../ui/OutlinedButton/OutlinedButton";
import { CssTextField } from "../../TextInputField/TextInputField";
import classes from "./ContactsModal.module.scss";
import { ContactsType } from "./module/constants";
import messages from "./module/messages";

interface ContactsModalProps {
  isChangeMobile?: boolean;
  isLogin?: boolean;
  show: boolean;
  smsEnabled?: boolean;
  onClose: () => void;
  onSelect: (method: ContactsType, userCode?: string) => void;
}

function ContactsModal({
  onClose,
  onSelect,
  show,
  isLogin = false,
  isChangeMobile = false,
  smsEnabled = false,
}: ContactsModalProps) {
  const [userCode, setUserCode] = useState<string>("");

  const handleUserFieldChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target) {
      const usr = event.target.value;
      setUserCode(usr);
    }
  };

  return (
    <>
      <Modal show={show} size="sm" onHide={onClose} centered>
        <Modal.Header className={classes.header}>
          <Modal.Title style={{ fontSize: "1rem" }}>
            <FormattedMessage {...messages.uigpContactMethod} />
          </Modal.Title>
          <FaTimes onClick={onClose} className={classes.closeIcon} />
        </Modal.Header>
        <Modal.Body>
          {isLogin && (
            <div
              className="col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-center flex-wrap"
              style={{ marginBottom: "1rem" }}
            >
              <CssTextField
                variant="filled"
                fullWidth
                type={"text"}
                onChange={handleUserFieldChange}
                value={userCode}
                label={<FormattedMessage {...messages.usernameLabel} />}
              />
            </div>
          )}
          <div className={classes.content}>
            {((smsEnabled && !isChangeMobile) || isLogin) && (
              <OutlinedButton
                onClick={() => onSelect(ContactsType.SMS, userCode)}
                disabled={isLogin && userCode === ""}
              >
                SMS
              </OutlinedButton>
            )}
            <OutlinedButton
              onClick={() => onSelect(ContactsType.EMAIL, userCode)}
              disabled={isLogin && userCode === ""}
            >
              EMAIL
            </OutlinedButton>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default ContactsModal;
